import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TICKET_TYPE } from 'src/app/core/enums/ticket-type.enum';
import { Ticket } from '../../domain/model/ticket.model';
import { TICKET_REPOSITORY } from '../../domain/tokens/ticket.token';

/**
 * Service responsible for retrieving the most recently updated simple ticket
 * Filters tickets by type 'simple' and returns the one with the latest updatedAt timestamp
 */
@Injectable({
  providedIn: 'root'
})
export class GetLastSimpleTicketService {
  private readonly ticketRepository = inject(TICKET_REPOSITORY);

  execute(): Observable<Ticket | null> {
    return this.ticketRepository.getAllTickets().pipe(
      map((tickets: Ticket[]) => this.findMostRecentSimpleTicket(tickets))
    );
  }

  private findMostRecentSimpleTicket(tickets: Ticket[]): Ticket | null {
    if (!tickets?.length) {
      return null;
    }

    let mostRecentTicket: Ticket | null = null;
    let latestUpdatedAt = 0;

    for (const ticket of tickets) {
      if (ticket.type === TICKET_TYPE.simple && ticket.updatedAt > latestUpdatedAt) {
        latestUpdatedAt = ticket.updatedAt;
        mostRecentTicket = ticket;
      }
    }

    return mostRecentTicket;
  }
}
